import React, { useState } from "react";
import FxApp from "./pages/FxPage";
import RatesApp from "./pages/RatesPage";
import CurveApp from "./pages/CurvesPage";
import BTApp from "./pages/BTPage";
import { F, SANS } from "./pages/theme";
import { HEADER_H } from "./pages/ui";

export default function TangoAlphaSuite(){
  const [tab, setTab] = useState('rates');
  const TABS = [
    { id: 'fx',    label: 'TangoAlpha FX',    sub: 'EUR/USD spot options',          accent: '#58a6ff' },
    { id: 'rates', label: 'TangoAlpha Rates', sub: 'EUR swaption strategies',       accent: '#fbbf24' },
    { id: 'curve', label: 'TangoAlpha Curve', sub: 'Steepeners & flatteners',       accent: '#bc8cff' },
    { id: 'bt',    label: 'TangoAlpha BT',    sub: 'Swaption strategy backtests',   accent: '#34d399' },
  ];
  const active = TABS.find(t => t.id === tab);

  return (
    <div style={{minHeight:'100vh', background:'#06090f', color:'#e6edf3', fontFamily:SANS}}>
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap" rel="stylesheet"/>
      {/* TAB BAR — height must match HEADER_H in ui.js */}
      <div style={{height:HEADER_H, display:'flex', alignItems:'stretch', background:'#0a0a0a',
                   borderBottom:'1px solid #1f2937', position:'sticky', top:0, zIndex:100}}>
        <div style={{display:'flex', alignItems:'center', padding:'0 18px',
                     borderRight:'1px solid #1f2937', gap:8}}>
          <div style={{width:24, height:24, borderRadius:6,
                       background:`linear-gradient(135deg, #58a6ff, #fbbf24)`,
                       display:'flex', alignItems:'center', justifyContent:'center',
                       fontWeight:800, fontSize:F.xs, color:'#06090f'}}>T</div>
          <div>
            <div style={{fontSize:F.xs, fontWeight:700, letterSpacing:'-.01em'}}>TANGO ALPHA</div>
            <div style={{fontSize:F.xxs-3, color:'#6b7280', letterSpacing:'.12em', textTransform:'uppercase'}}>Strategy Suite</div>
          </div>
        </div>
        {TABS.map(t => {
          const isActive = t.id === tab;
          return (
            <button key={t.id} onClick={()=>setTab(t.id)}
              style={{background: isActive ? '#10151e' : 'transparent',
                      border:'none', borderRight:'1px solid #1f2937',
                      borderBottom: isActive ? `2px solid ${t.accent}` : '2px solid transparent',
                      padding:'0 22px', cursor:'pointer', textAlign:'left',
                      color: isActive ? '#e6edf3' : '#7d8590',
                      fontFamily:'inherit', transition:'all 0.15s'}}>
              <div style={{fontSize:F.sm, fontWeight: isActive?700:500, letterSpacing:'-.01em',
                           color: isActive ? t.accent : 'inherit'}}>{t.label}</div>
              <div style={{fontSize:F.xxs-2, color:'#6b7280', letterSpacing:'.06em',
                           textTransform:'uppercase', marginTop:1}}>{t.sub}</div>
            </button>
          );
        })}
        <div style={{flex:1}}/>
        <div style={{display:'flex', alignItems:'center', padding:'0 18px', fontSize:F.xxs-2,
                     color:'#484f58', letterSpacing:'.1em', textTransform:'uppercase'}}>
          {active?.label}
        </div>
      </div>

      {/* APP CONTENT */}
      <div>
        {tab === 'fx' && <FxApp/>}
        {tab === 'rates' && <RatesApp/>}
        {tab === 'curve' && <CurveApp/>}
        {tab === 'bt' && <BTApp/>}
      </div>
    </div>
  );
}
